import CoverSpread from './CoverSpread';

export default CoverSpread;
